<template>
  <div id="app">
    <Header />
    <Player />
  </div>
</template>

<script>
import Header from './components/common/Header.vue'
import Player from './views/Player.vue'

export default {
  name: 'app',
  components: {
    Header,
    Player
  }
}
</script>

<style>
@import "./assets/styles/global.css";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}
</style>
